import MessageHelper from '../../../../helpers/MessageHelper';
import {StaticData} from '../data/StaticData';
import {CardData} from '../data/active_data/field_config/card_stack_data/CardData';
import {Stack} from '../pixi_scene/game_scene/game_table/table_objects/stacks/Stack';
import {CardSelector} from './CardSelector';
import {Card} from '../pixi_scene/game_scene/game_table/table_objects/stacks/Card';
import {ActiveData} from '../data/ActiveData';
import {HandEvents} from '../pixi_scene/game_scene/hand/HandEvents';

export class HandController
{
    static handHighLighted: boolean = false;
    static overHandIndex: number = 0;

    static moveCardsToHand(cards: CardData[]): void {
        MessageHelper.sendChangeCardsMessage(MessageHelper.TYPE_MOVE_CARD_TO_PLAYER, {
            ids: cards.map(card => card.id),
            playerId: StaticData.playerId,
            flip: [],
            handIndex: HandController.getHandIndex()
        });
    }

    static moveStacksToHand(stacks: Stack[]): void {
        MessageHelper.sendChangeStacksMessage(MessageHelper.TYPE_MOVE_TO_PLAYER, {
            ids: stacks.map(stacks => stacks.activeData.id),
            playerId: StaticData.playerId,
            flip: [],
            handIndex: HandController.getHandIndex()
        });
    }

    static moveXCardsOfStackToHand(stack: Stack, number: number) {
        HandController.moveCardsToHand(stack.activeData.cards.classes.concat().splice(stack.activeData.cards.length - number));
    }

    static highlightHand(): void {
        HandController.handHighLighted = true;
        dispatchEvent(new MessageEvent(HandEvents.HIGHLIGHT, {data: {}}));
    }

    static unhighlightHand() {
        HandController.handHighLighted = false;
        dispatchEvent(new MessageEvent(HandEvents.UNHIGHLIGHT, {data: {}}));
    }

    private static getHandIndex(): number {
        let highlightedCard: Card | null = CardSelector.highlighted();
        let index: number = HandController.overHandIndex;
        let filteredLength: number = ActiveData.root.getCurrentPlayerData().cards.classes.filter(cardData => cardData.config!.id != -1).length;
        if (highlightedCard) {
            index = ActiveData.root.getCurrentPlayerData().cards.indexOf(highlightedCard.activeData);
            index = Math.min(index, filteredLength);
        }
        return index;
    }
}
